import React from 'react'
import PropTypes from 'prop-types'
import useNavigationManager from '../hooks/use-navigation-manager'
import useSettingsManager from '../hooks/use-settings-manager'
import usePortManager from '../hooks/use-port-manager'
import { observer } from 'mobx-react'

function SimpleStepNav ({next = true, prev = true, nowrap = false, step_name = null}) {

  const manager = useNavigationManager()
  const settings_manager = useSettingsManager()
  const port_manager = usePortManager()

  const next_label = settings_manager.getOtherSettings('next_button_label', 'Næste')
  const prev_label = settings_manager.getOtherSettings('prev_button_label', 'Forrige')

  const disabled_next = step_name ? !port_manager.validateStep(step_name) : false

  if (typeof next !== 'boolean') {
    next = true
  }
  if (typeof prev !== 'boolean') {
    prev = true
  }

  const nextButtonClasses = prev === true ? 'next button primary' : 'next button primary right-align'

  const next_button = next === true ? <button
    className={nextButtonClasses}
    disabled={disabled_next}
    onClick={disabled_next ? null : () => manager.nextStep()}
  >
    {next_label}
  </button> : null

  const prev_button = prev === true ? <button
    className="prev button grey"
    onClick={() => manager.prevStep()}
  >
    {prev_label}
  </button> : null

  const wrap = function (children) {
    if (nowrap) {
      return <>{children}</>
    } else {
      return <div className={'simple-step-nav'}>{children}</div>
    }
  }

  return wrap(<>{prev_button}{next_button}</>)
}

export default observer(SimpleStepNav)